import { Fragment } from 'react';
import Metrics from '/@/components/metrics';
import NewMetricsMobile from '/@/components/new-metrics-mobile';
import { _, _lazy } from '/@/locale';
import { isMobile } from '/@/utils';

const DefensiveProfile = ({ brand, productRecommendations, country }) => {
    return (
        <Fragment>
            {!isMobile() ? (
                <Metrics
                    dots
                    title={_('Perfil defensivo')}
                    country={country}
                    dataKey='metrics'
                    products={productRecommendations.map((recommendation) => recommendation.profile)}
                    brand={brand}
                />
            ) : (
                <NewMetricsMobile
                    dots
                    title={_('Perfil defensivo')}
                    country={country}
                    dataKey='metrics'
                    products={productRecommendations.map((recommendation) => recommendation.profile)}
                    brand={brand}
                />
            )}
        </Fragment>
    );
};

DefensiveProfile.label = _lazy('Perfil defensivo');
DefensiveProfile.icon = 'defensiveProfile';

export default DefensiveProfile;
